import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetDDJJByTable, actionGetDDJJHistory, actionControlDDJ, registerOnChangeDDJJ } from "../actions/RestaurantActions"
import { withTheme } from "@material-ui/core/styles"
import { LOGIN_ROUTE } from "../config/RoutesConstants"
import Setting from "../provider/base/Settings"
import { 
  Container, 
  IconButton,
  Icon,
  Button,
  Box, 
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Input,
  InputLabel,
  InputAdornment,
  List,
  ListItem,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tabs,
  Tab,
  Tooltip
} from "@material-ui/core"
import CardDDJJ from "../components/CardDDJJ/CardDDJJ"
import DatePicker from "react-datepicker"
import 'react-datepicker/dist/react-datepicker.css';
import ButtonCalendar from "../components/ButtonCalendar/ButtonCalendar"
import SearchIcon from '@material-ui/icons/Search';
import DetailIcon from '@material-ui/icons/ListAlt';
import Util, { ERROR } from "../common/Util"
import Provinces from "../common/Provinces"
import moment from "moment"

class DDJJ extends React.PureComponent{
  constructor(props){
    super(props)
    //El from y el to de los filtros no se usan
    this.state = {page:0, rowPerPage:25, count:0, ddjjHistory:[], search:"", open:false, tabIndexSelected:0,
                  filter:{name:"", from:moment().add(-1,"month").toDate(), to: new Date()}}
    this.onSearch=this.onSearch.bind(this)
    this.onSearchKeyPress=this.onSearchKeyPress.bind(this)
    this.onClickSearch=this.onClickSearch.bind(this)
    this.getDDJJError=this.getDDJJError.bind(this)
    this.onSelectCalendar=this.onSelectCalendar.bind(this)
    this.onOpenCalendar=this.onOpenCalendar.bind(this)
    this.onSelectTable=this.onSelectTable.bind(this)
    this.onContol=this.onContol.bind(this)
    this.onChangeTab=this.onChangeTab.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.unsubscribe=null
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    this.props.actionGetDDJJByTable(this.state.filter, null, this.getDDJJError)
    if(this.props.profile){
      this.unsubscribe = registerOnChangeDDJJ(this.props.profile.proRestoId,()=>{
        this.setState({loadingData:true})
        if(this.state.tabIndexSelected==0){
          this.props.actionGetDDJJByTable(this.state.filter, (ddjj)=>{
            if(this.state.selectedTable){
              const idx = ddjj.findIndex((d)=>{return d.commerceTable==this.state.selectedTable.commerceTable})
              this.setState({selectedTable:ddjj[idx]})
            }
          },  this.getDDJJError)
        }
        if(this.state.tabIndexSelected==1){
          if(moment().isBetween(this.state.filter.from, this.state.filter.to, 'day')){
            this.props.actionGetDDJJHistory(this.state.filter,()=>this.onChangePage(),this.getDDJJError)
          }
        }  
      })
    }
  }

  componentWillUnmount(){
    this.unsubscribe&&this.unsubscribe()
  }
  
  getDDJJError(e){
    Util.showNoty(ERROR, "Ocurrió un error al consultar las DDJJ. Intente nuevamente")
  }

  onSearch(evt){
    this.setState({search:evt.target.value})
  }

  onSearchKeyPress(evt){
    const k = evt.which || evt.keyCode
    if(k==13) {//ENTER
      this.onClickSearch()
    }
  }

  onClickSearch(){
      let filter = this.state.filter
      filter.name = this.state.search
      this.setState({filter:filter})
      if(this.state.tabIndexSelected==0){
        this.props.actionGetDDJJByTable(filter, null, this.getDDJJError)
      }else{
        this.props.actionGetDDJJHistory(filter, ()=>this.onChangePage(), this.getDDJJError)
      }
  }

  onSelectCalendar(d){
    let ds = moment(d)
    const {from, to} = this.state.filter
    let filter = {...this.state.filter}
    let open = this.state.open
    if(from&&!to&&ds.isSameOrAfter(from,)){//Si está seleccionado el from y no el end y el valor es mayor al from, coloco el end
      filter.to=d
      open=false
      this.props.actionGetDDJJHistory(filter, ()=>this.onChangePage(), this.getDDJJError)
    }else{  //cualquier otro caso selecciono el from
      filter.from=d
      filter.to=null
    }
    this.setState({filter:filter, open:open})
  }

  onOpenCalendar(){
    this.setState({open:true})
  }

  onSelectTable(ddjj){
    this.setState({selectedTable:ddjj})
  }

  onContol(ddjj){
    this.props.actionControlDDJ(ddjj.detail)
    if(this.setState.selectedTable){
      this.setState({selectedTable:null})
    }
  }

  onChangeTab(evt, newIndex){
    this.setState({tabIndexSelected:newIndex})
    if(newIndex==0){
      this.props.actionGetDDJJByTable(this.state.filter, (ddjj)=>{
        if(this.state.selectedTable){
          const idx = ddjj.findIndex((d)=>{return d.commerceTable==this.state.selectedTable.commerceTable})
          this.setState({selectedTable:ddjj[idx]})
        }
      },  this.getDDJJError)
    }
    if(newIndex==1){
      this.props.actionGetDDJJHistory(this.state.filter,this.onChangePage,this.getDDJJError)
    }
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let ddjjHistory = this.props.ddjjHistory||[]
    let count = ddjjHistory.length
    ddjjHistory=ddjjHistory&&ddjjHistory.slice(from, end)
    this.setState({page:newPage, count:count, ddjjHistory:ddjjHistory, loadingData:false, changingState:false})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let ddjjHistory = this.props.ddjjHistory||[]
    let count = ddjjHistory.length
    ddjjHistory=ddjjHistory&&ddjjHistory.slice(from, end)
    this.setState({rowPerPage:evt.target.value, count:count, ddjjHistory:ddjjHistory})
  }


  renderItem(label, value){
    let isBoolean = typeof value == 'boolean'
    return (
      <Box style={{margin:4}}>
        <Typography style={{fontWeight:"bold"}}>{label}</Typography>
        <Typography style={{color:"rgb(0,0,0,0.8)"}}>{isBoolean?(value?"SI":"NO"):value}</Typography>
      </Box>
    )
  }

  renderDetailTable(){
    if(!this.state.selectedTable){
      return null
    }
    const {theme} = this.props
    let items = this.state.selectedTable.detail
    return (
      <ListItem>
        <Grid container spacing={2}>
          {
            items.map((item, index)=>{
              const ddjjDate = Util.timestampToMoment(item.ddjjDate)
              return (
                <Grid item>
                  <CardDDJJ item={item} textInCircle={index+1}/>
                </Grid>
              )
            })
          }
        </Grid>
      </ListItem>
    )
    
  }

  renderTab0(){
    const { ddjjList } = this.props
    console.log("RENDER TAB 0", ddjjList)
    if(!ddjjList||ddjjList.length==0){
      return (
        <Grid container  style={{margin:8}}>
          <Grid item>
            <Card variant="outlined">
              <CardContent style={{padding:8, backgroundColor:"#f5f5f5", textAlign:"center"}}>
                <Typography style={{justifyContent:"center", alignItems:"center", textAlign:"center", fontSize:18, paddingRight:24, paddingLeft:24}}>
                  No se encontraron DDJJ no controladas en la última hora.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )
    }
    return (
      <Grid container spacing={3} style={{margin:8}}>
        {ddjjList.map((ddjj)=>{
          return (
            <Grid item>
              <Card variant="outlined">
                <CardContent style={{padding:8, backgroundColor:"#f5f5f5", textAlign:"center"}}>
                  <Typography style={{justifyContent:"center", alignItems:"baseline", textAlign:"center", fontSize:18, paddingRight:24, paddingLeft:24, paddingTop:12}}>
                    Mesa {ddjj.commerceTable}  
                  </Typography>
                  <Divider/>
                  <Tooltip title="Ver DDJJ" placement="right">
                    <Button variant="contained" color="secondary" onClick={()=>{this.onSelectTable(ddjj)}}
                    style={{borderRadius:100, margin:8, paddingTop:15, paddingBottom:15}}>
                      <Typography style={{alignItems:"baseline", textAlign:"center",  fontSize:22, fontWeight:"bold"}}>
                        {ddjj.detail.length} 
                      </Typography>
                    </Button>
                  </Tooltip>
                  <Typography style={{fontSize:18, paddingBottom:8}}>DDJJ</Typography>
                </CardContent>
                <CardActions>
                  <Button color="primary" onClick={()=>{this.onContol(ddjj)}}>Marcar como controlado</Button>
                </CardActions>
              </Card>        
            </Grid>
          )
        })}
      </Grid>
    )
  }

  renderTab1(){
    const { theme } = this.props
    const { ddjjHistory } = this.state
    console.log("RENDER TAB 1", ddjjHistory)
    const headers = ["Mesa","Nombre y apellido", "DNI", "Teléfono", "E-mail", "Domicilio", "Fecha"]
    return [
      <Table stickyHeader >
        <TableHead>
          <TableRow >
            {headers.map((h)=><TableCell>{h}</TableCell>)}
            <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {ddjjHistory&&ddjjHistory.map((item)=>{
            let address = ""
            if(item.adrStreetComplete){
              address+=item.adrStreetComplete
            }
            if(item.adrCity){
              address+=", " + item.adrCity
            }
            if(item.adrState>=0&&item.adrState<=23){
              address+=", " + Provinces[item.adrState]
            }
            const ddjjDate = Util.timestampToMoment(item.ddjjDate)

            return (
              <TableRow>
                <TableCell>{item.commerceTable}</TableCell>
                <TableCell>{`${item.name} ${item.lastname}`}</TableCell>
                <TableCell>{Util.formatNumber(item.docNumber)}</TableCell>
                <TableCell>{item.phoneNumber}</TableCell>
                <TableCell>{item.email}</TableCell>
                <TableCell>{address}</TableCell>
                <TableCell>{ddjjDate.format("DD/MM/YYYY - HH:mm")}</TableCell>
                <TableCell>
                  <Tooltip title="Ver DDJJ completa">
                    <Button onClick={()=>{this.setState({selectedDetail:item})}}>
                      <IconButton>
                        <DetailIcon/>
                      </IconButton>
                    </Button>
                  </Tooltip>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>,
      <TableFooter>
      <TableRow>
        <TableCell align="right" style={{width:"70%"}}>
          {this.state.loadingData&&<CircularProgress size={20} color="primary"/>}
        </TableCell>
        <TableCell align="right">
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            labelRowsPerPage="DDJJ por página"
            component="div"
            count={this.state.count}
            rowsPerPage={this.state.rowPerPage}
            page={this.state.page}
            onChangePage={this.onChangePage}
            onChangeRowsPerPage={this.onChangeRowsPerPage}
          />
        </TableCell>
      </TableRow>
    </TableFooter>

      ]
  }

  render(){
    const { theme } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={theme.title.container}>
          <Typography variant="h1">Declaraciones Juradas</Typography>
          <Typography variant="subtitle1">Controla DDJJ</Typography>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">Listado de declaraciones juradas</Typography>
            <Toolbar style={theme.table.toolbar}>
              <Tabs value={this.state.tabIndexSelected} style={{backgroundColor:"black", color:"white"}} onChange={this.onChangeTab}>
                <Tab label="DDJJ por Mesa"/>
                <Tab label="DDJJ Histórico"/>
              </Tabs>
              <Box>
                <Input  placeholder="Nombre | DNI | Mesa" 
                        onChange={this.onSearch}
                        onKeyPress={this.onSearchKeyPress}
                        value={this.state.search}
                        style={{minWidth:220, marginRight:12}}
                        endAdornment={ 
                          <InputAdornment position="end">
                            <IconButton onClick={this.onClickSearch}>
                              <SearchIcon/>
                            </IconButton>
                          </InputAdornment> 
                        }
                  />              
              </Box>
              {this.state.tabIndexSelected==1&&
              <Box>
                <Typography className="MuiFormLabel-root MuiInputLabel-shrink">Fecha de DDJJ</Typography>
                <DatePicker 
                      onSelect={this.onSelectCalendar} 
                      selected={this.state.filter.from}
                      selectStart
                      selectEnd
                      startDate={this.state.filter.from}
                      endDate={this.state.filter.to}
                      shouldCloseOnSelect={false}
                      locale="es"
                      customInput={<ButtonCalendar from={this.state.filter.from} to={this.state.filter.to} period={"custom"} onPress={this.onOpenCalendar} />}
                      open={this.state.open}
                      popperPlacement="top-end"
                      >
                </DatePicker>
              </Box>}
            </Toolbar>
            {this[`renderTab${this.state.tabIndexSelected}`]()}
          </Paper>
        </Container>
        <Dialog open={this.state.selectedTable?true:false}>
          <DialogTitle>
            Declaraciones Juradas de la Mesa {this.state.selectedTable&&this.state.selectedTable.commerceTable}
          </DialogTitle>
          <DialogContent>
            <List>
              {this.renderDetailTable()}
            </List>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" onClick={()=>{this.setState({selectedTable:null})}}>Cerrar</Button>
            <Button variant="contained" color="secondary" onClick={()=>{this.onContol(this.state.selectedTable)}}>Marcar como controlado</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.selectedDetail?true:false}>
          <DialogTitle>
            Declaración Jurada
          </DialogTitle>
          <DialogContent>
              <CardDDJJ item={this.state.selectedDetail}/>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" onClick={()=>{this.setState({selectedDetail:null})}}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    ddjjList: store.evt.ddjjList,
    ddjjHistory: store.evt.ddjjHistory,
    profile: store.auth.profile,
		loading: store.app.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetDDJJByTable,
      actionGetDDJJHistory,
      actionControlDDJ,
      registerOnChangeDDJJ
      // actionGetRestaurants,
      // actionDeleteRestaurant,
      // actionStatisticsByRestaurant,
      // actionSelectRestaurant,
      // actionQRLink
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(DDJJ)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/DDJJ.js